import { useEffect, useMemo, useState } from "react";
import { createBoltDocumentTemplateApiClient } from "../../lib/apiClient/boltDocumentTemplateApiClient";
import { useBoltApiClient } from "@bolt/core";
import { LoadingV2, SectionPlaceholder } from "@ucl/library";

export const BoltDocumentTemplatePreview: React.FC<{
  documentTemplateId: string;
  modelName: string;
  modelId: string;
}> = ({ documentTemplateId, modelName, modelId }) => {
  const boltApiClient = useBoltApiClient();

  const [fileUrl, setFileUrl] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const boltDocumentTemplateApiClient = useMemo(
    () => createBoltDocumentTemplateApiClient(boltApiClient!),
    [boltApiClient]
  );

  useEffect(() => {
    setIsLoading(true);
    boltDocumentTemplateApiClient
      .populateDocumentTemplate(documentTemplateId, modelName, modelId)
      .then((blob) => {
        // Create a URL from the Blob
        const url = URL.createObjectURL(blob);
        setFileUrl(url);
      })
      .finally(() => {
        setIsLoading(false);
      });

    // Cleanup function to revoke the object URL when component unmounts
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, []);

  // Cleanup function to revoke the object URL when fileUrl changes
  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);

  if (isLoading) {
    return <LoadingV2 />;
  }

  if (!fileUrl) {
    return (
      <SectionPlaceholder label="Document Template could not be loaded." />
    );
  }

  return (
    <div className="bolt-document-template-preview">
      <object data={fileUrl} type="application/pdf"></object>
    </div>
  );
};
